import React from 'react';
import { FaHtml5, FaCss3Alt, FaJsSquare, FaReact, FaNode, FaPython, FaBootstrap } from 'react-icons/fa';
import { DiMongodb } from 'react-icons/di';
import './Skill.css';

export default function Skill() {
  return (
    <section id='skill' className='skills'>
      <div className='skill-heading'>
        <h1>Skills</h1>
      </div>
      <div className='skill-icons'>
        <div className='icon-card'>
          <FaHtml5 className='icon' />
          <p>HTML</p>
        </div>

        <div className='icon-card'>
          <FaCss3Alt className='icon' />
          <p>CSS</p>
        </div>
        <div className='icon-card'>
          <FaBootstrap className='icon' />
          <p>BootStrap</p>
        </div>
        <div className='icon-card'>
          <FaJsSquare className='icon' />
          <p>JavaScript</p>
        </div>
        <div className='icon-card'>
          <FaReact className='icon' />
          <p>ReactJS</p>
        </div>
        <div className='icon-card'>
          <FaNode className='icon' />
          <p>NodeJS</p>
        </div>
        <div className='icon-card'>
          <DiMongodb className='icon' />
          <p>MongoDB</p>
        </div>
        <div className='icon-card'>
          <FaPython className='icon' />
          <p>Python</p>
        </div>
      </div>
    </section>
  );
}
